import { FC } from 'react';
import { PlayCircleOutlined } from '@ant-design/icons';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import { useThemeContext, themeConfig } from '@/shared/theme';

type Props = {
  value: string;
};

export const VideoEdit: FC<Props> = ({ value }) => {
  const { theme } = useThemeContext();

  // No video url provided
  if (!value) {
    return (
      <Wrapper data-testid="video-component">
        <VideoPlaceholder
          style={{ background: themeConfig[theme].colors.imagePlaceholderBg }}
        >
          <PlayCircleOutlined
            style={{
              color: themeConfig[theme].colors.imagePlaceholderIconColor,
              fontSize: 75,
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        </VideoPlaceholder>
      </Wrapper>
    );
  }
  // Video url provided and is supported
  if (ReactPlayer.canPlay(value)) {
    return (
      <Wrapper data-testid="video-component">
        <Container>
          <ReactPlayer
            controls
            url={value}
            width="100%"
            height="100%"
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </Container>
      </Wrapper>
    );
  }
  // Video url provided but is not supported
  return (
    <div
      style={{
        fontWeight: 'bold',
        background: `repeating-linear-gradient(
            -55deg,
            #f7f7f7,
            #f7f7f7 10px,
            #ebebeb 10px,
            #ebebeb 20px
          )`,
        padding: 15,
        borderRadius: 8,
      }}
    >
      Unsupported video source
    </div>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const Container = styled.div`
  position: relative;
  padding-top: 56.25%; /* 720 / 1280 = 0.5625 */
`;

const VideoPlaceholder = styled.div`
  position: relative;
  border-radius: 8px;
  padding-top: 56.25%; /* 720 / 1280 = 0.5625 */
`;
